import { api, LightningElement } from "lwc";

export default class extends LightningElement {
  @api assistiveText: string = "";
  @api href: string = "";
}
